import { getBrazeUuid } from '@root/src/web/lib/getBrazeUuid';
import { hasRequiredConsents } from './hasRequiredConsents';
const buildFailureResponse = (name, value, data) => ({
    isSuccessful: false,
    failure: {
        field: name,
        data: value,
    },
    data,
});
const buildDependencies = (isSignedIn, idApiUrl) => {
    return [
        {
            name: 'brazeSwitch',
            value: Promise.resolve(window.guardian.config.switches.brazeSwitch),
        },
        {
            name: 'apiKey',
            value: Promise.resolve(window.guardian.config.page.brazeApiKey),
        },
        {
            name: 'brazeUuid',
            value: isSignedIn ? getBrazeUuid(idApiUrl) : Promise.resolve(null),
        },
        {
            name: 'consent',
            value: hasRequiredConsents(),
        },
        {
            name: 'isNotPaidContent',
            value: Promise.resolve(!window.guardian.config.page.isPaidContent),
        },
    ];
};
const checkBrazeDependencies = async (isSignedIn, idApiUrl) => {
    const dependencies = buildDependencies(isSignedIn, idApiUrl);
    const data = {};
    // I think we could possibly clean this up a bit when we can use
    // Promise.allSettled reliably (it's not available in our current Node
    // version and polyfill.io doesn't have a polyfill yet).
    for (const { name, value } of dependencies) {
        try {
            // eslint-disable-next-line no-await-in-loop
            const result = await value;
            if (result) {
                data[name] = result;
            }
            else {
                return buildFailureResponse(name, result, data);
            }
        }
        catch (e) {
            const error = e;
            return buildFailureResponse(name, error && error.message ? error.message : error, data);
        }
    }
    return {
        isSuccessful: true,
        data,
    };
};
export { checkBrazeDependencies };
